export const BASE_API = 'https://api.shrtco.de/v2/shorten?url='

export const MESSAGE = {
    error: 'Your link might be invalid or was interrupted. Try again?',
    copied: 'Copied!'
}